import type { Designer, DesignerListParams } from '@/types/designer'
import type { PageResult } from '@/types/task'
import { httpClient } from '@/utils/request'

/**
 * Designers Module API
 * Handles designer and manufacturer recommendation and listing
 */

const Api = {
  // Recommend APIs (Backend implemented)
  GetRecommendDesigners: '/designers/recommend',
  GetRecommendManufacturers: '/manufacturers/recommend',

  // Designer List and Detail APIs
  GetDesignerList: '/designers',
  GetDesignerDetail: '/designers/',
} as const

/**
 * Get recommended designers list
 * Backend implemented: /api/designer/recommend
 * @param params Query parameters for filtering
 */
export function getRecommendDesigners(params?: DesignerListParams) {
  return httpClient.get<PageResult<Designer>>(Api.GetRecommendDesigners, { params })
}

/**
 * Get recommended manufacturers list
 * Backend implemented: /api/manufacturer/recommend
 * @param params Query parameters for filtering
 */
export function getRecommendManufacturers(params?: DesignerListParams) {
  return httpClient.get<PageResult<Designer>>(Api.GetRecommendManufacturers, { params })
}

/**
 * Get designers list
 * @param params Query parameters for pagination, filtering, etc.
 */
export function getDesignerList(params?: DesignerListParams) {
  return httpClient.get<PageResult<Designer>>(Api.GetDesignerList, { params })
}

/**
 * Get designer detail by ID
 * @param id Designer ID
 */
export function getDesignerDetail(id: string | number) {
  return httpClient.get<Designer>(`${Api.GetDesignerDetail}${id}`)
}
